module.exports = __webpack_public_path__ + "assets/img/NPC002.3b62ec84.png";